import { ElementRef } from '@angular/core';
import { CallbackType } from './prism.type';
;
//# sourceMappingURL=prism.interface.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@angular-package/prism/core/prism.interface.js
// module id = 635
// module chunks = 7